import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Suspense as _Suspense, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ec7d7ed8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["hidden"];
const _hoisted_2 = {
    key: 0,
    class: "list"
};
const _hoisted_3 = {
    key: 0,
    class: "fund"
};
const _hoisted_4 = { class: "checkbox-section" };
const _hoisted_5 = { class: "container-label" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "checkmark" }, null, -1));
const _hoisted_7 = { class: "checkbox-label" };
const _hoisted_8 = { class: "flex buttons" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
    key: 0,
    class: "lds-dual-ring"
};
const _hoisted_11 = {
    key: 1,
    class: "btn-txt"
};
import { ref } from 'vue';
import Loading from '@/materials/molecules/Loading.vue';
import ConnectionError from '@/materials/atoms/ConnectionError.vue';
import StakingDetails from '@/components/organisms/main/staking/stakingcancellation/StakingDetails.vue';
import CancellationConfirm from '@/components/organisms/main/staking/stakingcancellation/CancellationConfirm.vue';
import CancellationError from '@/components/organisms/main/staking/stakingcancellation/CancellationError.vue';
import { useStakingList } from '@/logics/stakinglist';
import { useMessage } from '@/const/messages';
import StakingFundCard from '@/components/organisms/main/staking/stakingcancellation/StakingFundCard.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        userInfo: null,
        isAuth: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { format, STAKING_LIST_TITLES } = useMessage();
        const isLoading = ref(false);
        const isList = ref(true);
        const isConfirm = ref(false);
        const isShowModal = ref(false);
        const isShowError = ref(false);
        const spinner = ref(false);
        const disableBtn = ref(true);
        const { cancelStakingFund } = useStakingList();
        const cancelStatus = ref();
        const fund = ref();
        const showDetails = (value, data) => {
            fund.value = data;
            isList.value = value;
            isConfirm.value = true;
        };
        const backToList = () => {
            isList.value = true;
            isConfirm.value = false;
            disableBtn.value = true;
        };
        const onClose = () => {
            isShowModal.value = false;
            isShowError.value = false;
            isList.value = true;
            isConfirm.value = false;
            disableBtn.value = true;
        };
        const isCheck = (event) => {
            disableBtn.value = !event;
        };
        const cancelFund = () => __awaiter(this, void 0, void 0, function* () {
            if (confirm(format(STAKING_LIST_TITLES.ALERT)) === true) {
                disableBtn.value = true;
                spinner.value = true;
                cancelStatus.value = yield cancelStakingFund(fund.value.id, props.userInfo.id).catch((err) => {
                    console.error(err);
                    return [];
                });
                cancelStatus.value.status === 200 ? (isShowModal.value = true) : (isShowError.value = true);
                if (cancelStatus.value) {
                    disableBtn.value = false;
                    spinner.value = false;
                }
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (isShowModal.value)
                    ? (_openBlock(), _createBlock(CancellationConfirm, {
                        key: 0,
                        onClose: onClose
                    }))
                    : _createCommentVNode("", true),
                (isShowError.value)
                    ? (_openBlock(), _createBlock(CancellationError, {
                        key: 1,
                        onClose: onClose
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: "staking-title",
                    hidden: isConfirm.value
                }, _toDisplayString(_unref(format)(_unref(STAKING_LIST_TITLES).STAKING_LIST)), 9, _hoisted_1),
                (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                        (!isLoading.value && isList.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(StakingFundCard, {
                                    "is-auth": props.isAuth,
                                    class: "list_currencies",
                                    onIsList: showDetails,
                                    userInfo: __props.userInfo
                                }, null, 8, ["is-auth", "userInfo"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    fallback: _withCtx(() => [
                        _createVNode(Loading)
                    ]),
                    error: _withCtx(() => [
                        _createVNode(ConnectionError)
                    ]),
                    _: 1
                })),
                (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                        (!isLoading.value && isConfirm.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(StakingDetails, { fund: fund.value }, null, 8, ["fund"]),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("label", _hoisted_5, [
                                        _createElementVNode("input", {
                                            type: "checkbox",
                                            onChange: _cache[0] || (_cache[0] = (event) => isCheck(event.target.checked))
                                        }, null, 32),
                                        _hoisted_6
                                    ]),
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(format)(_unref(STAKING_LIST_TITLES).CHECKBOX)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("button", {
                                        disabled: disableBtn.value,
                                        class: _normalizeClass(disableBtn.value ? 'act-btn disable-btn' : 'act-btn'),
                                        onClick: cancelFund
                                    }, [
                                        (spinner.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(format)(_unref(STAKING_LIST_TITLES).SUBMIT)), 1))
                                    ], 10, _hoisted_9),
                                    _createElementVNode("div", {
                                        class: "cancel",
                                        onClick: backToList
                                    }, _toDisplayString(_unref(format)(_unref(STAKING_LIST_TITLES).CANCEL)), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    fallback: _withCtx(() => [
                        _createVNode(Loading)
                    ]),
                    error: _withCtx(() => [
                        _createVNode(ConnectionError)
                    ]),
                    _: 1
                }))
            ], 64));
        };
    }
});
